app.components.quiz = {
    global: false,
    data: {
        selectedLevel: null,
        step: "quiz_intro",
    },
    onReady: function () {
        if ($('.c-quiz').length === 1 ) {
            return true;
        }
        return false;
    },
    addListener: async function () {
        this.container = document.querySelector('.c-quiz');
        this.initRadioButtons();
        const nextButtons  = document.querySelectorAll(".c-quiz__slide .navigation button.next");
        nextButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                const slide = button.closest(".c-quiz__slide");
                const step = slide.getAttribute("data-step");
                const level = slide.getAttribute("data-level");
                let n = parseInt(slide.getAttribute("data-question-number"));
                const nQuestions = parseInt(slide.getAttribute("data-total-in-level"));
                const isValidated = slide.classList.contains("validated");

                if (step === "quiz_intro") {
                    return this.gotToStep("select_level");
                }
                if (step === "select_level") {
                    if (!this.data.selectedLevel) {
                        console.warn("No level selected. Please select a level before proceeding.");
                        return;
                    }
                    return this.gotToStep(`${this.data.selectedLevel}-1`);
                }

                if (isValidated) {
                    if (level && n && n < nQuestions) {
                        return this.gotToStep(`${level}-${parseInt(n) + 1}`);
                    }
                    const resultsData = this.calculateResults(level, nQuestions);
                    return this.gotToStep(resultsData.step, resultsData.minPoints, resultsData);
                }
                return slide.classList.add("validated");
              
            });
        });
        const prevButtons  = document.querySelectorAll(".c-quiz__slide .navigation button.prev");
        prevButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                const slide = button.closest(".c-quiz__slide");
                const step = slide.getAttribute("data-step");
                const level = slide.getAttribute("data-level");
                let n = parseInt(slide.getAttribute("data-question-number"));

                if (step === "select_level") {
                    return this.gotToStep("quiz_intro");
                }
                if (step === "quiz_intro") {
                    return this.gotToStep("quiz_intro");
                }
                slide.classList.remove("validated");
                if (n && n === 1) {
                    return this.gotToStep("select_level");
                }
                if (level && n && n > 1) {
                    const step = `${level}-${parseInt(n) - 1}`;
                    const prevSlide = this.container.querySelector(`[data-step="${step}"]`);
                    prevSlide.classList.remove("validated");
                    return this.gotToStep(`${level}-${parseInt(n) - 1}`);
                }
                return this.gotToStep("select_level");
            })
        });
    },

    gotToStep: function(step, minPoints = null, resultsData = null) {
        let targetSlide;
        if (minPoints !== null) {
            // Use more specific selector when minPoints is provided
            targetSlide = this.container.querySelector(`[data-step="${step}"][data-min-points="${minPoints}"]`);
        } else {
            targetSlide = this.container.querySelector(`[data-step="${step}"]`);
        }
        
        const currentSlide = this.container.querySelector(".c-quiz__slide.current");
        if (targetSlide) {
            if (currentSlide) {
                currentSlide.classList.remove("current");
            }
            targetSlide.classList.add("current");
            this.data.step = step;
            
            // Save results to database when navigating to a results step
            if (resultsData && step.includes('-results')) {
                this.saveResults(resultsData);
            }
        } else {
            console.error(`Target slide for step "${step}" not found.`);
        }
    },

    calculateResults: function(level, totalQuestions) {
        // Find all validated slides for this level
        const levelSlides = this.container.querySelectorAll(`[data-level="${level}"].validated`);
        
        let correctAnswers = 0;
        
        // Count correct answers by checking if checked radio buttons are followed by feedback--correct
        levelSlides.forEach((slide) => {
            const checkedRadio = slide.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                const answerOption = checkedRadio.closest('.answer_option');
                const feedback = answerOption.nextElementSibling;
                if (feedback && feedback.classList.contains('feedback--correct')) {
                    correctAnswers++;
                }
            }
        });
        
        // Find all results slides for this level
        const resultsSlides = Array.from(this.container.querySelectorAll(`[data-step^="${level}-results"]`));
        
        // Update scores in all results slides for this level
        resultsSlides.forEach((resultsSlide) => {
            const correctSpan = resultsSlide.querySelector('.results_score .correct');
            const totalSpan = resultsSlide.querySelector('.results_score .total');
            
            if (correctSpan) {
                correctSpan.textContent = correctAnswers;
            }
            if (totalSpan) {
                totalSpan.textContent = totalQuestions;
            }
        });
        
        // Find the appropriate results screen based on score
        // Filter to those where data-min-points <= correctAnswers
        const eligibleResults = resultsSlides
            .map(slide => ({
                slide: slide,
                minPoints: parseInt(slide.getAttribute('data-min-points') || 0),
                step: slide.getAttribute('data-step')
            }))
            .filter(result => result.minPoints <= correctAnswers)
            .sort((a, b) => b.minPoints - a.minPoints); // Sort descending by minPoints
        
        // Return the step ID and minPoints of the results screen with the largest data-min-points
        if (eligibleResults.length > 0) {
            return {
                step: eligibleResults[0].step,
                minPoints: eligibleResults[0].minPoints,
                correctAnswers: correctAnswers,
                totalQuestions: totalQuestions
            };
        }
        
        // Fallback to the first results screen if no eligible one found
        return {
            step: resultsSlides.length > 0 ? resultsSlides[0].getAttribute('data-step') : `${level}-results`,
            minPoints: null,
            correctAnswers: correctAnswers,
            totalQuestions: totalQuestions
        };
    },
        
    initRadioButtons: function() {
        const radioButtons = this.container.querySelectorAll(".c-quiz__slide input[type='radio']");
        radioButtons.forEach((radio) => {
            radio.addEventListener("change", (e) => {
                const currentSlide = e.target.closest(".c-quiz__slide");
                const nextButton = currentSlide.querySelector(".navigation button.next ");
                if (nextButton) {
                    nextButton.disabled = false;
                }
            });
        });
        const selectLevelRadios = this.container.querySelectorAll("[data-step='select_level'] input[type='radio']");
        selectLevelRadios.forEach((radio) => {
            radio.addEventListener("change", (e) => {
                const selectedLevel = e.target.value;
                this.data.selectedLevel = selectedLevel;
            });
        });
    },

    saveResults: function(resultsData) {
        // Get quiz ID from data attribute
        const quizId = this.container.getAttribute('data-quiz-id');
        
        if (!quizId) {
            console.error('Quiz ID not found');
            return;
        }

        // Build options string for AJAX request
        const options = [
            'action:save_results',
            `quiz_id:${quizId}`,
            `level:${this.data.selectedLevel}`,
            `correct_answers:${resultsData.correctAnswers}`,
            `total_questions:${resultsData.totalQuestions}`
        ].join(';');

        // Make AJAX request
        const endpoint = '?component=quiz&options=' + options;
        $.get(endpoint)
            .done(function(response) {
                console.log('Quiz results saved successfully', response);
            })
            .fail(function(error) {
                console.error('Failed to save quiz results', error);
            });
    },
};